export default "__VITE_ASSET__D7MZN$Ii__"